module.exports = __webpack_public_path__ + "static/img/shengjimingdai.451d934.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/shengjimingdai.png
// module id = pblI
// module chunks = 1